import { useMutation } from "@apollo/react-hooks";
import _str from "shared/util/_str";
import {
	USER_UPDATE_PHONE_MUTATION,
	getUserUpdatePhoneSuccess,
	getUserUpdatePhoneStatusCode,
	UPDATE_PHONE_STATUS_CODES,
} from "shared/mutations/sms";
import { HAS_PHONE_QUERY } from "analytics/sms";
import noop from "shared/util/noop";
import FeedbackBanner from "shared/util/FeedbackBanner";


const getBannerMessage = (statusCode) => {
	const UPDATE_PHONE_ERROR_MESSAGES = {
		[UPDATE_PHONE_STATUS_CODES.PHONE_TAKEN]: _str("This phone number is already associated with another account."),
		[UPDATE_PHONE_STATUS_CODES.BLACKLISTED]: _str("This phone number is banned."),
	};
	const defaultMessage = _str("Error updating phone");

	return UPDATE_PHONE_ERROR_MESSAGES[statusCode] || defaultMessage;
};

const updateHasPhoneCache = (cache, response) => {
	const success = getUserUpdatePhoneSuccess(response);

	cache.writeQuery({
		query: HAS_PHONE_QUERY,
		data: {
			session: {
				__typename: "Session",
				gatekeeperChecks: {
					HAS_PHONE: success,
					__typename: "GatekeeperChecks",
				},
			},
		},
	});
};

// useUpdatePhone returns a function to be used after
// an otp code is verified in the PhoneVerificationFlow
function useUpdatePhone(handleSuccess = noop) {
	const [updateUserPhone] = useMutation(USER_UPDATE_PHONE_MUTATION, {
		update: updateHasPhoneCache,
	});

	const handlePhoneVerified = (tspRefreshToken, newPhoneNumber) => {
		return updateUserPhone({ variables: { input: { tspRefreshToken } } })
			.then((response) => {
				const success = getUserUpdatePhoneSuccess(response);
				const statusCode = getUserUpdatePhoneStatusCode(response);

				if (!success) {
					FeedbackBanner.open({
						message: getBannerMessage(statusCode),
						type: "error",
						timeout: 4000,
					});

					// tell the PhoneVerificationFlow to go back to the phone screen
					return Promise.reject({
						statusCode,
						goBackToPhone: true,
					});
				}

				return handleSuccess(newPhoneNumber);
			});
	};

	return handlePhoneVerified;
}

export default useUpdatePhone;



// WEBPACK FOOTER //
// ./src/shared/hooks/useUpdatePhone.js